var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('back-btn'),_c('v-container',[_c('v-row',[_c('v-col',[_c('create-form',{on:{"submitForm":_vm.submitData}})],1)],1),_c('v-row',[_c('v-col',[_c('list',{attrs:{"datas":_vm.datas}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }